import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    close: 'Exit',
    description: 'Follow the progress of your application.',
    inProgress: 'In progress',
    steps: {
      companyCreation: {
        description:
          'You download your deposit certificate and send your complete file to the Greffe.',
        title: 'Company creation',
      },
      companyStructure: {
        description:
          'You fill the information about your future company, your beneficiaries and shareholders.',
        title: 'Application submission',
      },
      fundsDeposit: {
        description: 'You deposit your capital on a dedicated bank account.',
        title: 'Funds deposit',
      },
      fundsRelease: {
        description:
          'Your capital is transferred to your Shine pro account once we receive your Kbis.',
        title: 'Release of funds and Shine account opening',
      },
      legalVerification: {
        description:
          'We validate your application once you send your draft statutes.',
        title: 'Legal verification',
      },
    },
    title: 'Deposit your capital with Shine',
  },
  fr: {
    close: 'Fermer',
    description: 'Suivez l’avancement de votre dossier.',
    inProgress: 'En cours',
    steps: {
      companyCreation: {
        description:
          'Vous téléchargez votre certificat de dépôt et envoyez votre dossier complet au greffe.',
        title: 'Création de votre entreprise',
      },
      companyStructure: {
        description:
          'Vous renseignez les informations relatives à votre future entreprise, vos bénéficiaires et actionnaires.',
        title: 'Constitution du dossier',
      },
      fundsDeposit: {
        description:
          'Vous effectuez votre dépôt de capital sur un compte bancaire dédié.',
        title: 'Dépôt des fonds',
      },
      fundsRelease: {
        description:
          'Nous transférons votre capital sur votre compte pro Shine dès réception de votre Kbis.',
        title: 'Libération des fonds et ouverture de votre compte Shine',
      },
      legalVerification: {
        description:
          'Nous vérifions votre projet de statuts (dès que tous les actionnaires ont envoyé leurs documents si vous avez des associé·e·s).',
        title: 'Vérification du dossier',
      },
    },
    title: 'Dépôt de capital',
  },
} as const);
